export default function (Alpine) {
    Alpine.store('calсForm', {
        open: false,

        show() {
            this.open = true;
        },

        close() {
            this.open = false;
        },
    });
}
